import { axiosInstance } from '../axios';
import { ITiledeskConfig } from './types';

export async function getTiledeskConfig(): Promise<ITiledeskConfig> {
  const { data } = await axiosInstance.get<ITiledeskConfig>('/tiledesk/config/');
  return data;
}
